module.exports = __webpack_public_path__ + "img/package_5_gray.41ad38d9.png";